import styled from 'styled-components';

export const Wrapper = styled.ul<{
  isDecimal?: boolean;
}>`
  margin-top: 12px;
  padding-left: 16px;
  list-style-type: ${(props) => (props.isDecimal ? 'decimal' : 'disc')};

  > li {
    line-height: 20px;

    > a {
      color: #5b36f2;
      text-decoration: underline;
    }
  }
`;
